var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search",style:(_vm.cptStyles)},[_c('div',{staticClass:"content",style:(_vm.inputStyles),on:{"click":_vm.gotoPage}},[_c('van-icon',{staticClass:"search-icon",style:([_vm.iconStyles]),attrs:{"name":"search"}}),_c('span',{style:([_vm.fontColorStyle])},[_vm._v(_vm._s(_vm.placeholderText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }